<div class="wish-list">
  <div class="title flex" (click)="onBack()" *ngIf="!isDesktop">
    <img src="assets/images/icons/left-arrow.svg" alt="Arrow Left Icon" />
    <p>Wishlist</p>
  </div>
  <div
    class="empty-wishlist flex"
    *ngIf="!scrollOption.isFirstCall && products?.length < 1"
  >
    <img
      src="assets/images/icons/empty-wishlist.svg"
      alt="Empty Wishlist"
      *ngIf="!isDesktop"
    />
    <img
      src="assets/images/icons/empty-wishlist-desktop.svg"
      alt="Empty Wishlist"
      *ngIf="isDesktop"
    />
    <p>Your Wishlist is Empty</p>
  </div>
  <div
    class="products-row"
    infiniteScroll
    [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScrollProducts()"
  >
    <ng-container *ngIf="!isDesktop">
      <div class="product-card w-full" *ngFor="let product of products">
        <shared-product-card
          class="w-full"
          [product]="product"
          [titleRequired]="true"
        ></shared-product-card>
        <div class="favorite-icon" (click)="removeFromFavorite(product.id)">
          <img src="assets/images/icons/favorite.svg" alt="favorite" />
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isDesktop">
      <div class="product-card" *ngFor="let product of products">
        <img
          class="product-logo"
          [src]="product?.logo"
          alt="{{ product?.name }} Logo"
        />
        <div class="product-detail">
          <p class="product-title">{{ product?.name }}</p>
          <div class="discount">
            <div class="discount-badge-container" *ngIf="product.discount > 0">
              <div class="badge-symbol">
                <div class="symbol-line"></div>
                <div class="symbol-circle"></div>
              </div>
              <div class="badge-primary">
                {{ product.discount | convertPrice
                }}<span class="badge-primary-icon">%</span>
              </div>
              <div class="badge-secondary">
                <span class="badge-context">Discount</span>
              </div>
            </div>
            <div
              class="favorite-icon pointer"
              (click)="removeFromFavorite(product.id)"
            >
              <img src="assets/images/icons/favorite.svg" alt="favorite" />
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div
    class="loading-spinner"
    *ngIf="!scrollOption.isFinish && !scrollOption.isFirstCall"
  >
    <mat-spinner diameter="50" color="primary"></mat-spinner>
  </div>
</div>
